import { type ReactNode, useState, createContext, useContext } from "react";
import { styled } from "@mui/material/styles";

type LoadingContextType = [boolean, React.Dispatch<React.SetStateAction<boolean>>];

export const LoadingContext = createContext<LoadingContextType>([false, () => null]);
export const LocalisedLoadingContext = LoadingContext;

export const useLoadingContext = (): LoadingContextType => useContext(LoadingContext);

export const StyledLoader = styled("div")(() => ({
  height: "100%",
  position: "absolute",
  top: 0,
  right: 0,
  bottom: 0,
  left: 0,
  "& .loader": {
    position: "absolute",
    top: "calc(50% - 30px)",
    left: "calc(50% - 30px)",
    border: "6px solid #f3f3f3",
    borderRadius: "50%",
    borderTop: `6px solid #83E2C2`,
    width: 60,
    height: 60,
    animation: "spin 2s linear infinite",
  },
  "& .small": {
    borderWidth: 3,
    width: 30,
    height: 30,
    top: "calc(50% - 15px)",
    left: "calc(50% - 15px)",
  },
  "@keyframes spin": {
    "0%": { transform: "rotate(0deg)" },
    "100%": { transform: "rotate(360deg)" },
  },
}));

// LoadingProvider Component
interface LoadingProviderProps {
  children: ReactNode;
}

function LoadingProvider({ children }: LoadingProviderProps) {
  const loadingState = useState(false);
  const [loading] = loadingState;

  return (
    <LoadingContext.Provider value={loadingState}>
      {children}
      {loading && (
        <StyledLoader>
          <div className="loader small" />
        </StyledLoader>
      )}
    </LoadingContext.Provider>
  );
}

export default LoadingProvider;
